// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 53 ? "webfontloader" : chunkId) + "." + {"36":"99766bc5","53":"38e6fda4","706":"2eee68fd"}[chunkId] + ".js";
};